<template>
  <div class="content">
    <TopBar
      barTheme="white"
      :barStyle="`background: url(${require('@/assets/images/personal_top_bg.png')}) no-repeat; background-size: 100%;`"
    >
      <span class="page-title" slot="title">我的礼品</span>
    </TopBar>
    <div class="gift">
      <div class="gift-list">
        <div class="list-hd wrap">
          <ul class="tab-box">
            <li
              :class="`hvc ${activeIndex === 0 ? 'cur' : ''}`"
              @click="changeTab(0)"
            >
              全部礼品
            </li>
            <li
              :class="`hvc ${activeIndex === 1 ? 'cur' : ''}`"
              @click="changeTab(1)"
            >
              待发货
            </li>
            <li
              :class="`hvc ${activeIndex === 2 ? 'cur' : ''}`"
              @click="changeTab(2)"
            >
              待审核
            </li>
          </ul>
        </div>
        <div class="list-bd">
          <div class="show-box wrap" v-if="giftList.length > 0">
            <ul>
              <li
                v-for="(item, index) in giftList"
                :key="item.Id"
                :data-index="index"
              >
                <div
                  class="li-inner"
                  v-if="item.OrderItemModels[0].BenefitsProductType !== 20"
                >
                  <div class="number vc">兑换编号：{{ item.SerialNumber }}</div>
                  <div class="order-detail">
                    <div class="gift-wrap vc">
                      <div class="pic-box vc">
                        <img :src="item.OrderItemModels[0].ImageUrl" alt="" />
                      </div>
                      <div class="text-box">
                        <h3 class="el">{{ item.OrderItemModels[0].Name }}</h3>
                        <p>
                          兑换时间：<span class="black">{{
                            item.CreatedTime.replace(/\:/g, "/")
                          }}</span>
                        </p>
                        <p>
                          兑礼积分：<span
                            class="black"
                            v-if="item.OrderItemModels[0].UnitPrice"
                            >{{
                              item.OrderItemModels[0].UnitPrice *
                              item.OrderItemModels[0].Quantity
                            }}积分</span
                          >
                        </p>
                        <p>
                          兑换状态：<span
                            class="cur"
                            v-bind:class="{
                              finished: checkStatus(
                                item.ApprovalStatus,
                                item.ShippingStatus,
                                item.OrderStatus,
                                item.OrderStatus,
                                item.OrderItemModels[0].ProductNature
                              ).isFinish,
                            }"
                            >{{
                              checkStatus(
                                item.ApprovalStatus,
                                item.ShippingStatus,
                                item.OrderStatus,
                                item.OrderStatus,
                                item.OrderItemModels[0].ProductNature
                              ).text
                            }}</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="aside-box">
                      <a
                        class="btn-item btn-address hvc"
                        href="javascript: void(0)"
                        v-if="
                          item.IsShowShipmentAddress && !item.IsShowFillAddress
                        "
                        @click="seeShipment(index)"
                        >收件地址</a
                      >
                      <a
                        class="btn-item btn-logistics hvc"
                        href="javascript: void(0)"
                        v-if="item.IsShowLogistics"
                        @click="showLogistics(item.Shipment)"
                        >查看物流</a
                      >
                      <a
                        class="btn-item btn-exchange hvc"
                        href="javascript: void(0)"
                        v-if="item.IsShowExchangeInfo"
                        @click="showExchangeInfo(item.OrderItemModels[0])"
                        >兑礼信息</a
                      >
                      <a
                        class="btn-item btn-use hvc"
                        :href="item.OrderItemModels[0].UseUrl"
                        v-if="item.IsShowUse"
                        >立即使用</a
                      >
                      <a
                        class="btn-item btn-fill hvc"
                        href="javascript: void(0)"
                        v-if="item.IsShowFillAddress"
                        >填写地址</a
                      >
                    </div>
                  </div>
                </div>
                <div class="li-inner" v-else>
                  <div class="number vc">ID：{{ item.SerialNumber }}</div>
                  <div class="order-detail">
                    <div class="gift-wrap vc">
                      <div class="pic-box vc">
                        <img :src="item.OrderItemModels[0].ImageUrl" alt="" />
                      </div>
                      <div class="text-box">
                        <h3 class="el">{{ item.OrderItemModels[0].Name }}</h3>
                        <p>
                          发放时间：<span class="black">{{
                            item.CreatedTime.replace(/\:/g, "/")
                          }}</span>
                        </p>
                        <p v-if="item.ChannelName">
                          发放渠道：<span class="cur finished">{{
                            item.ChannelName
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <div class="aside-box">
                      <a
                        class="btn-item btn-address hvc"
                        href="javascript: void(0)"
                        v-if="
                          item.IsShowShipmentAddress && !item.IsShowFillAddress
                        "
                        @click="seeShipment(index)"
                        >收件地址</a
                      >
                      <a
                        class="btn-item btn-logistics hvc"
                        href="javascript: void(0)"
                        v-if="item.IsShowLogistics"
                        @click="showLogistics(item.Shipment)"
                        >查看物流</a
                      >
                      <a
                        class="btn-item btn-exchange hvc"
                        href="javascript: void(0)"
                        v-if="item.IsShowExchangeInfo"
                        @click="showExchangeInfo(item.OrderItemModels[0])"
                        >兑礼信息</a
                      >
                      <a
                        class="btn-item btn-use hvc"
                        :href="item.OrderItemModels[0].UseUrl"
                        v-if="item.IsShowUse"
                        >立即使用</a
                      >
                      <a
                        class="btn-item btn-fill hvc"
                        href="javascript: void(0)"
                        v-if="item.IsShowFillAddress"
                        @click="updateAddress(item)"
                        >填写地址</a
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <infinite-loading
            @infinite="infiniteHandler"
            ref="infiniteLoading"
            :identifier="thisIdentifier"
          >
            <span slot="no-more"></span>
            <div class="blank-tip" slot="no-results">
              <div class="tip-box">
                <i class="icon icon-blank"></i>
                <p>您还没有任何兑换记录哦！</p>
                <router-link
                  tag="a"
                  class="btn-item btn-obtain hvc"
                  to="/member/shop/index"
                  >去兑换</router-link
                >
              </div>
            </div>
          </infinite-loading>
        </div>
        <div class="info-layer" v-if="isShowLayer" @click.self="close">
          <div class="layer-wrap">
            <div class="layer-title vc">
              <i class="icon icon-line"></i>
              <h3>{{ infoTitle }}</h3>
            </div>
            <div class="layer-content">
              <div class="info-item vc">
                {{ item_01 }}：{{ item_01_detail }}
              </div>
              <div class="info-item vc" v-if="item_02 || item_03">
                {{ item_02 }}：{{ item_02_detail }}
                <div class="item-aside vc" v-if="item_03">
                  <i class="icon icon-line-black"></i>
                  {{ item_03 }} {{ item_03_detail }}
                </div>
              </div>
            </div>
            <a
              class="btn-item btn-close"
              href="javascript: void(0)"
              @click="close"
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/libs/api.request";
import InfiniteLoading from "vue-infinite-loading";
import { dateFormat, urlSearchToObject } from "@/libs/tools";
import TopBar from "@/components/top-bar/";
import img from "@/assets/images/pro_03.png";
import { mapMutations } from "vuex";
export default {
  name: "giftList",
  components: {
    TopBar,
    InfiniteLoading,
  },
  data: () => {
    return {
      img,
      state: 10,
      pageSize: 10,
      pageIndex: 1,
      giftList: [],
      activeIndex: 0,
      isLoading: 0, // 正在加载状态值
      thisIdentifier: Date.now(),
      isShowLayer: false,
      infoTitle: "",
      item_01: "",
      item_01_detail: "",
      item_02: "",
      item_02_detail: "",
      item_03: "",
      item_03_detail: "",
      product: {},
    };
  },
  mounted() {
    this.storeToken();
    this.checkCustomerInfo().then((res) => {
      if (!res) {
        let href = window.location.href;
        window.location.href = `/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=${encodeURIComponent(
          href
        )}`;
      }
    });
  },
  methods: {
    ...mapMutations(["setToken"]),
    storeToken() {
      let token = urlSearchToObject().token;
      let cookieToken = this.$store.state.user.token;
      if (!token && !cookieToken) {
        let href = window.location.href;
        window.location.href = `/Rccl.Campaign/MemberCenter/Auth?redirectUrl=${encodeURIComponent(
          href
        )}`;
      }
      if (token && token !== cookieToken) {
        this.setToken(token);
      }
    },
    formatTime(time) {
      let timestamp = new Date(time).getTime();
      return dateFormat(timestamp, "YYYY-MM-DD");
    },
    close() {
      this.isShowLayer = false;
      this.clearData();
    },
    clearData() {
      this.infoTitle = "";
      this.item_01 = "";
      this.item_01_detail = "";
      this.item_02 = "";
      this.item_02_detail = "";
      this.item_03 = "";
      this.item_03_detail = "";
    },
    showLogistics(shipment) {
      this.isShowLayer = true;
      this.infoTitle = "查看物流信息";
      this.item_01 = "物流公司";
      this.item_01_detail = shipment.LogisticsCompanies;
      this.item_02 = "物流单号";
      this.item_02_detail = shipment.TrackingNumber;
    },
    showExchangeInfo(order) {
      this.isShowLayer = true;
      this.infoTitle = "查看兑礼信息";
      this.item_01 = "礼品名称";
      this.item_01_detail = order.Name;
      if (order.VirtualProductType === 10 || order.VirtualProductType === 20) {
        this.item_02 = "";
        this.item_02_detail = '';
      } else if (order.VirtualProductType === 40) {
        this.item_02 = "";
        this.item_02_detail = '';
      } else if (order.VirtualProductType === 30) {
        this.item_02 = "礼品信息";
        this.item_02_detail = "账号 " + order.Account;
        this.item_03 = "密码";
        this.item_03_detail = order.Password;
      } else if (
        order.VirtualProductType === 50 ||
        order.VirtualProductType === 60
      ) {
        this.item_02 = "礼品兑换码";
        this.item_02_detail = order.CodeData;
      }
      /*if (order.Password) {
                    this.item_02_detail = '账号 ' + order.Account
                    this.item_03 = '密码'
                    this.item_03_detail = order.Password
                } else {
                    this.item_02_detail = order.CodeData
                }*/
    },
    checkStatus(ApprovalStatus, ShippingStatus, OrderStatus, ProductNature) {
      switch (ApprovalStatus) {
        case 20:
          return {
            text: "待审核（7天内反馈）",
            isFinish: false,
          };
        case 40:
          return {
            text: "兑礼失败",
            isFinish: false,
          };
        default:
          switch (ShippingStatus) {
            case 20:
              return {
                text: "待发货",
                isFinish: false,
              };
            case 30:
              return {
                text: "已发货",
                isFinish: true,
              };
            case 40:
              return {
                text: "已收货",
                isFinish: true,
              };
            default:
              switch (OrderStatus) {
                case 10:
                  return {
                    text: "待审核（7天内反馈）",
                    isFinish: false,
                  };
                case 20:
                  return {
                    text: "待发货",
                    isFinish: false,
                  };
                case 30:
                  return {
                    text: "已发货",
                    isFinish: true,
                  };
                case 40:
                  return {
                    text: "兑礼失败",
                    isFinish: false,
                  };
                case 50:
                  switch (ProductNature) {
                    case 20:
                      return {
                        text: "已发放",
                        isFinish: true,
                      };
                    default:
                      return {
                        text: "兑礼完成",
                        isFinish: true,
                      };
                  }
                case 60:
                  return {
                    text: "正在处理",
                    isFinish: false,
                  };
              }
          }
      }
    },
    infiniteHandler($state) {
      this.isLoading = 1; // 正在加载
      axios
        .request({
          url: "/pro/Store/CMOrder/List",
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.user.token}`,
          },
          data: {
            state: this.state,
            pageSize: this.pageSize,
            pageIndex: this.pageIndex,
          },
        })
        .then((res) => {
          let data = res.data;
          if (data.errCode === 0) {
            this.isLoading = 0; // 加载完成
            let rows = data.data.rows;
            if (rows.length > 0) {
              this.giftList = [...this.giftList, ...rows];
              $state.loaded();
              this.pageIndex += 1;
            } else {
              $state.complete();
            }
          } else if (data.errCode === 1000) {
            window.console.log("失败");
          } else {
            window.console.log("系统错误");
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    changeTab(index) {
      if (this.isLoading) return false;
      this.activeIndex = index;
      this.state = (index + 1) * 10;
      this.giftList = [];
      this.pageIndex = 1;
      this.thisIdentifier = Date.now(); // 子组件监听本属性进行重载
    },
    seeShipment(index) {
      let item = this.giftList[index];
      this.$router.push({
        path: "/commodity/shipment",
        name: "shipmentAddress",
        params: {
          productId: item.OrderItemModels[0].ProductId,
          userName: item.RecipientName,
          userTel: item.PhoneNumber,
          userAdd:item.City || "",
          address: item.Address,
        },
      });
    },
    updateAddress(item) {
      let pro = item.OrderItemModels[0];
      if (pro.GiftType === 10) {
        this.$router.push(
          `/commodity/account?Id=${pro.ProductId}&VirtualProductType=${pro.VirtualProductType}&orderId=${item.Id}&update=true`
        );
      } else if (pro.GiftType === 20) {
        this.$router.push(
          `/commodity/receiving?Id=${pro.ProductId}&VirtualProductType=${pro.VirtualProductType}&orderId=${item.Id}&update=true`
        );
      } else if (pro.GiftType === 30) {
        this.$router.push(
          `/commodity/coupon?Id=${pro.ProductId}&VirtualProductType=${pro.VirtualProductType}&orderId=${item.Id}&update=true`
        );
      }
    },
    checkCustomerInfo() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiCheckCustomerInfo",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-title {
  color: #fff;
}
.gift {
  padding-top: 1.91rem;
  background-color: #f5f6f8;
  .personal-info {
    height: 3rem;
    padding-top: 1.24rem;
    background: url("../../../assets/images/personal_top_bg.png") no-repeat;
    background-size: 100%;
    color: #fff;
    .current-integral {
      text-align: center;
      p {
        line-height: 1;
      }
      h3 {
        margin-top: 0.06rem;
        font-size: 0.48rem;
        line-height: 1;
      }
    }
    .integral-tip {
      height: 0.32rem;
      padding-top: 0.28rem;
      .icon-line {
        width: 0.02rem;
        height: 0.26rem;
        margin: 0 0.16rem;
        background-color: #fff;
      }
    }
  }
  .gift-list {
    padding-bottom: 0.9rem;
    .list-hd {
      position: fixed;
      left: 0;
      top: 1rem;
      width: 100%;
      height: 0.91rem;
      background-color: #fff;
      .tab-box {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        height: 100%;
        li {
          width: 1.44rem;
          height: 100%;
          padding-top: 0.06rem;
          padding-bottom: 0.06rem;
          font-size: 0.3rem;
          &.cur {
            padding-bottom: 0;
            border-bottom: #4a90e2 solid 0.06rem;
            color: #4a90e2;
          }
        }
      }
    }
    .list-bd {
      min-height: calc(100vh - 1rem - 0.91rem - 0.9rem);
      ul {
        padding-bottom: 0.2rem;
        li {
          margin-top: 0.2rem;
          background-color: #4a90e2;
          border-radius: 0.06rem;
          overflow: hidden;
          .number {
            height: 0.4rem;
            padding: 0 0.2rem;
            color: #fff;
          }
          .order-detail {
            padding-top: 0.2rem;
            background-color: #fff;
            border-radius: 0.06rem;
            .gift-wrap {
              display: flex;
              display: -webkit-flex;
              padding: 0 0.2rem;
              .pic-box {
                width: 2.25rem;
                height: 1.44rem;
                overflow: hidden;
                img {
                  width: 100%;
                }
              }
              .text-box {
                width: 4.24rem;
                padding-left: 0.2rem;
                h3 {
                  font-size: 0.3rem;
                  line-height: 0.36rem;
                }
                p {
                  margin-top: 0.14rem;
                  line-height: 1;
                  color: #747d80;
                }
                .black {
                  color: #282b2c;
                }
                .cur {
                  color: #ffa70d;
                }
                .finished {
                  color: #4a90e2;
                }
              }
            }
            .aside-box {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-end;
              -webkit-justify-content: flex-end;
              padding: 0.1rem 0.2rem 0.2rem;
              .btn-item {
                display: flex;
                display: -webkit-flex;
                margin-left: 0.09rem;
                margin-top: 0.1rem;
                width: 1.3rem;
                height: 0.44rem;
                border: #4a90e2 solid 0.02rem;
                border-radius: 0.22rem;
                color: #4a90e2;
              }
            }
          }
        }
      }
      .blank-tip {
        height: calc(100vh - 1rem - 0.91rem - 0.9rem);
        padding-top: 1.74rem;
        background-color: #f6f7f8;
        .tip-box {
          width: 2.95rem;
          margin: 0 auto;
          text-align: center;
          .icon-blank {
            width: 2.03rem;
            height: 1.73rem;
            background: url("../../../assets/images/blank.png") no-repeat;
            background-size: 100% 100%;
          }
          p {
            margin-top: 0.3rem;
            color: #919b9f;
            line-height: 1;
          }
          .btn-obtain {
            display: flex;
            display: -webkit-flex;
            width: 2.75rem;
            height: 0.6rem;
            margin-top: 0.3rem;
            background-color: #fbc500;
            border-radius: 0.3rem;
          }
        }
      }
    }
    .info-layer {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 999;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.78);
      .layer-wrap {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 6.9rem;
        height: 2.51rem;
        padding: 0.4rem;
        background-color: #fff;
        border-radius: 0.1rem;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        .layer-title {
          height: 0.72rem;
          padding: 0.18rem 0;
          .icon-line {
            width: 0.04rem;
            height: 0.3rem;
            margin-right: 0.1rem;
            background-color: #fbc500;
            border-radius: 0.02rem;
          }
          h3 {
            font-size: 0.3rem;
          }
        }
        .layer-content {
          padding-top: 0.1rem;
          .info-item {
            height: 0.36rem;
            margin-bottom: 0.07rem;
            .item-aside {
              height: 100%;
            }
            .icon-line-black {
              width: 0.02rem;
              height: 0.24rem;
              margin: 0 0.14rem;
              background-color: #282b2c;
            }
          }
        }
        .btn-close {
          position: absolute;
          left: 50%;
          bottom: -0.9rem;
          width: 0.7rem;
          height: 0.7rem;
          transform: translateX(-50%);
          background: url("../../../assets/images/btn_close.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
